var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('Header',{class:{ 'homeNav': _vm.$route.path == '/', 'otherNav': _vm.$route.path !== '/' }}),_c('router-view',{attrs:{"directionSliderNav":_vm.directionSliderNav},on:{"directionSliderNav":v => _vm.directionSliderNav = v}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }